import {
    EXPORT_TO_CSV_FAILURE,
    EXPORT_TO_CSV_REQUEST,
    EXPORT_TO_CSV_SUCCESS,
    EXPORT_TO_IMAGE_FAILURE,
    EXPORT_TO_IMAGE_REQUEST,
    EXPORT_TO_IMAGE_SUCCESS,
    EXPORT_TO_PDF_FAILURE,
    EXPORT_TO_PDF_REQUEST,
    EXPORT_TO_PDF_SUCCESS,
} from './types/export-report-action-types';

import ReportService from '../../common/services/reports-service';
import { exportParamsSelector } from '../selectors/reports-selectors';
import moment from 'moment';

import { openExportToImageErrorSnackbar } from '../../common/actions/snackbar-action-creators';

// PDF
function requestExportToPdf(){
    return {
        type: EXPORT_TO_PDF_REQUEST
    };
}
function exportToPdfSuccess(){
    return {
        type: EXPORT_TO_PDF_SUCCESS
    };
}
function exportToPdfFailure( error ){
    return {
        error,
        type: EXPORT_TO_PDF_FAILURE,
    };
}

function showFile( blob, type, ext ){
    // It is necessary to create a new blob object with mime-type explicitly set
    // otherwise only Chrome works like it should
    const newBlob = new Blob( [blob], { type: type } );

    // IE doesn't allow using a blob object directly as link href
    // instead it is necessary to use msSaveOrOpenBlob
    if( window.navigator && window.navigator.msSaveOrOpenBlob ){
        window.navigator.msSaveOrOpenBlob( newBlob );
        return;
    }

    // For other browsers:
    // Create a link pointing to the ObjectURL containing the blob.
    const data = window.URL.createObjectURL( newBlob );
    const link = document.createElement( 'a' );
    link.href = data;
    link.download = `report-${moment().valueOf()}${ext}`;
    document.body.appendChild( link );
    link.click();
    setTimeout( () => {
        // For Firefox it is necessary to delay revoking the ObjectURL
        document.body.removeChild( link );
        window.URL.revokeObjectURL( data );
    }, 100 );
}

export function exportToPdf(){
    return ( dispatch, getState, { DATA_API } ) => {
        dispatch( requestExportToPdf() );
        const state = getState();
        const { dateRange, interval, domain, domainType, report } = exportParamsSelector( state );
        const reportService = new ReportService( DATA_API );
        return reportService.getPdf( dateRange, interval, domain, domainType, report )
            .then( ( request ) => showFile( request.data, 'application/pdf', '.pdf' ) )
            .then(
                () => dispatch( exportToPdfSuccess() ),
                ( error ) => dispatch( exportToPdfFailure( error.response ) )
            );
    };
}

// IMAGE
function requestExportToImage( chartName ){
    return {
        chartName,
        type: EXPORT_TO_IMAGE_REQUEST,
    };
}

function exportToImageSuccess( chartName ){
    return {
        chartName,
        type: EXPORT_TO_IMAGE_SUCCESS,
    };
}

function exportToImageFailure( chartName, error ){
    return {
        chartName,
        error,
        type: EXPORT_TO_IMAGE_FAILURE,
    };
}

export function exportToImage( chartName ){
    return ( dispatch, getState, { DATA_API } ) => {
        const state = getState();
        dispatch( requestExportToImage( chartName ) );
        const { dateRange, interval, domain, domainType, dmarcPassType, report } = exportParamsSelector( state );
        const reportService = new ReportService( DATA_API );
        return reportService.getImage( dateRange, interval, domain, domainType, report, chartName, dmarcPassType )
            .then( ( request ) => showFile( request.data, 'image/png', '.png' ) )
            .then(
                () => dispatch( exportToImageSuccess( chartName ) ),
                ( error ) => {
                    dispatch( exportToImageFailure( chartName, error.response ) );
                    dispatch( openExportToImageErrorSnackbar() );
                }
            );
    };
}


export function exportToCSV( tableName ){
    return {
        tableName,
        type: EXPORT_TO_CSV_REQUEST,
    };
}

export function exportToCSVSuccess( tableName ){
    return {
        tableName,
        type: EXPORT_TO_CSV_SUCCESS,
    };
}

export function exportToCSVFailure( tableName, error ){
    return {
        error,
        tableName,
        type: EXPORT_TO_CSV_FAILURE,
    };
}
